<template>
  <base-section id="committee">
    <v-container>
    <base-section-heading
    title="Organizing Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
    <v-col
      cols="12"
      md="6"
    >
    <strong>General Co-Chairs<br /></strong>
    Victor Champac<br />
    Yervant Zorian - Synopsys, USA<br />
    <br /><strong>Vice General Chair<br /></strong>
    Carlos Silva Cardenas - Pontificia Universidad Católica del Perú, Peru<br />
    <br /><strong>Local Co-Chairs<br /></strong>
    Jimmy Fernando Tarrillo - UTEC, Peru<br />
    Juan Tisza - National University of Engineering, Peru<br />
    <br /><strong>Program Co-Chairs<br /></strong>
    Leticia Bolzani Poehls - IHP, Germany<br />
    Ernesto Sanchez - Politecnico di Torino, Italy<br />
    <br /><strong>Embedded Tutorial Co-Chairs<br /></strong>
    Ioana Vatajelu - TIMA Laboratory, France<br />
    Angeliki Kritikakou - Rennes University, France<br />
    <br /><strong>Special Session Co-Chairs<br /></strong>
    Graziano Pravadelli - University of Verona, Italy<br />
    Felipe Restrepo Calle - Universidad Nacional de Colombia, Colombia<br />
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
    <strong>Panel Co-Chairs<br /></strong>
    Fabian Luis Vargas - IHP, Germany<br />
    Marcelo Lubaszewski - UFRGS, Brazil<br />
    <br /><strong>Student Activities Co-Chairs<br /></strong>
    Annachiara Ruospo - Politecnico di Torino, Italy<br />
    Cristina Meinhardt - UFSC, Brazil<br />
    <br /><strong>Financial Co-Chair<br /></strong>
    Hector Villacorta - Universidad Politécnica de Aguascalientes, Mexico<br />
    <br /><strong>Web Chair<br /></strong>
    Giusy Iara - Politecnico di Torino, Italy<br />
    <br /><strong>Publicity Co-Chair<br /></strong>
    Nicolo Bellarmino - Politecnico di Torino, Italy<br />
    <br /><strong>USA Liaison<br /></strong>
    Abhijit Chatterje - Georgia Tech, USA<br />
    <br /><strong>Asia Liaison<br /></strong>
    Xiaoqing Wen - Kyushu Institute of Technology, Japan<br />
    <br /><strong>Europe Liaison<br /></strong>
    Matteo Sonza Reorda - Politecnico di Torino, Italy<br />
    </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Steering Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="(program, i) in steerings"
        :key="i"
        cols="12"
        md="6"
      >
        <base-section
          space="0"
          style="text-align: left"
        >
          {{ program.title }} - <i>{{ program.text }}</i>
        </base-section>
      </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Program Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <strong>TBA</strong>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Committee',

    data: () => ({
      steerings: [
          {
          text: "INAOE, Mexico",
          title: "Victor Champac",
          },
          {
          text: "UFRGS, Brazil",
          title: "Marcelo Lubazewski ",
          },
          {
          text: "IHP GmbH, Germany",
          title: "Fabian Vargas",
          },
          {
          text: "TIMA, France",
          title: "Raoul Velazco",
          },
          {
          text: "Synopsys, USA",
          title: "Yervant Zorian",
          },
          {
          text: "UFRGS, Brazil",
          title: "Tiago Balen",
          },
          {
          text: "Politecnico di Torino, Italy",
          title: "Ernesto Sanchez",
          },
          {
          text: "IHP - Leibniz Institute for High Performance Microelectronics, Germany",
          title: "Leticia M. Bolzani Pöhls",
          },
          {
          text: "Politecnico di Torino, Italy",
          title: "Matteo Sonza Reorda",
          },
      ],
      programs: [
          {
          text: "Universidade Federal de Viçosa",
          title: "Josè Augusto Nacif",
          },
          {
            text: "UFSC",
            title: "Cristina Meinhardt",
          },
          {
            text: "McMaster University",
            title: "Nicola Nicolici",
          },
          {
          text: "Synopsys",
          title: "Gurgen Harutyunyan",
          },
          {
          text: "Delft University of Technology",
          title: "Mottaqiallah Taouil",
          },
          {
          text: "University of California San Diego",
          title: "Alex Orailoglu",
          },
          {
          text: "Kyushu University",
          title: "Xiaoqing Wen",
          },
          {
          text: "UFRGS",
          title: "Paulo F. Butzen",
          },
          {
          text: "Lyon Institute of Nanotechnology",
          title: "Alberto Bosio",
          },
          {
          text: "IHP - Leibniz Institute for High Performance Microelectronics",
          title: "Milos Krstic",
          },
          {
          text: "University of Stuttgart",
          title: "Hans-Joachim Wunderlich",
          },
          {
          text: "TIMA Laboratory",
          title: "Regis Leveugle",
          },
          {
          text: "PUCP",
          title: "Carlos Silva-Cardenas",
          },
          {
          text: "INP - TIMA Laboratory",
          title: "Elena-Ioana Vatajelu",
          },
          {
          text: "CNRS",
          title: "Giorgio Di Natale",
          },
          {
          text: "University of Piraeus",
          title: "Mihalis Psarakis",
          },
          {
          text: "Politecnico di Torino",
          title: "Ernesto Sanchez",
          },
          {
          text: "Politecnico di Torino",
          title: "Massimo Violante",
          },
          {
          text: "University of Grenoble Alpes",
          title: "Rodrigo Possamai Bastos",
          },
          {
          text: "Politecnico di Milano",
          title: "Antonio Miele",
          },
          {
          text: "IHP - Leibniz Institute for High Performance Microelectronics, Germany",
          title: "Fabian Vargas",
          },
          {
          text: "Politecnico di Torino",
          title: "Matteo Sonza Reorda",
          },
          {
          text: "Universidade Federal do Rio Grande do Sul",
          title: "Fernanda Kastensmidt",
          },
          {
          text: "German Aerospace Center (DLR)",
          title: "Frank Sill Torress",
          },
          {
          text: "Universidad Nacional de Colombia",
          title: "Felipe Restrepo-Calle",
          },
          {
          text: "Federal University of Paraiba",
          title: "Cleonlinson Protasio",
          },
          {
          text: "TIMA Laboratory",
          title: "Emmanuel Simeu",
          },
          {
          text: "University of Bremen",
          title: "Rolf Drechsler",
          },
          {
          text: "RWTH Aachen University",
          title: "Supriya Chakraborty",
          },
          {
            text: "Lund University",
            title: "Erik Larsson",
          },
          {
            text: "RWTH Aachen University",
            title: "Thiago Santos Copetti",
          },
          {
          text: "TIMA Laboratory",
          title: "Paolo Maistri",
          },
          {
          text: "University of Paderborn",
          title: "Sybille Hellebrand",
          },
          {
          text: "Universidad de la Republica",
          title: "Julio Perez Acle",
          },
          {
            text: "LIRMM",
            title: "Patrick Girard",
          },
          {
            text: "Politecnico di Torino",
            title: "Stefano Di Carlo",
          },
          {
          text: "Grenoble-INP/TIMA",
          title: "Mounir Benabdenbi",
          },
          {
          text: "Devices and Sensors Group, Bariloche Atomic Center (CNEA)",
          title: "José Lipovetzky",
          },
          {
          text: "Sorbonne Université, CNRS, LIP6",
          title: "Haralampos-G. Stratigopoulos",
          },
          {
          text: "Inria Rennes / IRISA",
          title: "Marcello Traiola",
          },
          {
            text: "Delft University of Technology",
            title: "Moritz Fieback",
          },
          {
            text: "University of Applied Sciences Nordhausen",
            title: "Mario Schölzel",
          },
          {
            text: "TIMA Laboratory",
            title: "Salvador Mir",
          },
          {
            text: "University of Grenoble Alpes",
            title: "Lorena Anghel",
          },
          {
            text: "Institut TELECOM, Télécom-ParisTech",
            title: "Lirida Naviner",
          },
          {
            text: "University of Rennes 1 - IRISA/INRIA",
            title: "Angeliki Kritikakou",
          },
          {
            text: "Tallinn University of Technology",
            title: "Mohammad Hasan Ahmadilivani",
          },
          {
            text: "CNRS - IES - University of Montpellier",
            title: "Luigi Dilillo",
          },
          {
            text: "IRISA, France",
            title: "Lorenzo Casalino",
          },
          {
            text: "IRISA, France",
            title: "Ruben Salvador",
          },
      ],

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
